import FileService from '../../../services/file-service';
import FormService from '../../../services/form-service';
import FormatService from '../../../services/format-service';
import { FILE_EXTENSION_LIST_IMAGE } from '../../../constants/system/file-extensions';

const SettingsAccountListValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const formKeyNew: string = FormService.getIndexedFormFieldKey(FormService.FORM_KEY_NEW);

  const requiredFields: string[] = [
    'name',
    'role',
    'accountSubscriptionPlan',
    'systemAdminUserEmail',
    'systemAdminUserPassword',
    'systemAdminUserPasswordConfirm',
  ];

  if (values.accountListData) {
    if (!errors.accountListData) {
      errors.accountListData = {};
    }

    Object.keys(values.accountListData).forEach((accountIndex: string): void => {
      const accountData: ValidationEntityInput = {
        ...values.accountListData[accountIndex],
      };

      if (accountData) {
        if (!errors.accountListData[accountIndex]) {
          errors.accountListData[accountIndex] = {};
        }

        requiredFields.forEach((field: string): void => {
          if ((!accountData[field] || !accountData[field].toString().trim()) && accountData[field] !== null) {
            errors.accountListData[accountIndex][field] = 'Required';
          }
        });

        if (accountData.photo && !FileService.checkFileExtension(accountData.photo, FILE_EXTENSION_LIST_IMAGE)) {
          errors.accountListData[accountIndex].photo = 'Incorrect file type';
        }

        if (accountData.systemAdminUserEmail && !FormatService.isValidEmail(accountData.systemAdminUserEmail)) {
          errors.accountListData[accountIndex].systemAdminUserEmail = 'Invalid email address';
        }

        if (accountData.systemAdminUserPassword
          && !FormatService.isValidPassword(accountData.systemAdminUserPassword)) {
          errors.accountListData[accountIndex].systemAdminUserPassword = `Password must contain `
            + `${FormService.PASSWORD_FIELD_LENGTH_MIN} characters, at least one letter in lower case, one letter `
            + 'in upper case and one number or one symbol';
        }

        if (accountData.systemAdminUserPassword && accountData.systemAdminUserPasswordConfirm
          && accountData.systemAdminUserPassword !== accountData.systemAdminUserPasswordConfirm) {
          errors.accountListData[accountIndex].systemAdminUserPasswordConfirm = 'Password confirmation does not match';
        }

        if (errors.accountListData[accountIndex] && (
          !Object.keys(errors.accountListData[accountIndex]).length
          || (accountIndex === formKeyNew && accountData.name === null)
        )) {
          delete errors.accountListData[accountIndex];
        }
      }
    });

    if (errors.accountListData && !Object.keys(errors.accountListData).length) {
      delete errors.accountListData;
    }
  }

  return errors;
};

export default SettingsAccountListValidator;
